import { makeFilterString } from "../utils/Helper";
import {
  GetEventPlanningSuccess,
  EventPlanningLoading,
  SetEventPlanning,
} from "./Actions";

import { reduxRequest } from "../../../common/utils/reduxRequest";

export const getEventPlanningRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventPlanningLoading,
    loadingType: "list",
    successFunction: GetEventPlanningSuccess,
    url: `/admin/event_planning${makeFilterString(variables?.params)}`,
    method: "get",
  };
  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const updateEventPlanningRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventPlanningLoading,
    loadingType: "update",
    url: `/admin/event_planning/${variables?.id}`,
    action: variables?.action,
    data: variables?.body,
    method: "put",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};

export const getEventPlanningDetailsRequest = ({ ...variables }) => {
  const requestData = {
    isLoading: EventPlanningLoading,
    loadingType: "details",
    successFunction: SetEventPlanning,
    url: `/admin/event_planning/${variables?.id}`,
    method: "get",
  };

  return async (dispatch) => {
    reduxRequest({
      dispatch,
      ...requestData,
    });
  };
};
